// src/modules/app-views/_apps/appmulti/orders/pages/Document/tabs/VoucherTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useState } from 'react';
import { Button, Card, Descriptions, Space, Typography } from 'antd';
import { AuditOutlined, CarryOutOutlined, EditOutlined, UploadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import { useDocumentContext } from 'components/core/DocumentProvider';
import translateX from 'utils/translateX';
import { parseCpfToDisplay } from 'utils/helpers';
import AddVoucherModal from './modals/AddVoucherModal';

// *******************************************************************************
// GLOBAL VARIABLES
// *******************************************************************************
const { Link } = Typography;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const VoucherTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, refreshDocument } = useDocumentContext();
  const record = data || {};
  const canInsert = (record?.__statusView || record?.status) === 'waiting_for_voucher';

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const onInsert = t => {
    setSelected(t);
    setOpen(true);
  };

  const onSaved = () => {
    setOpen(false);
    if (typeof refreshDocument === 'function') refreshDocument(record._id);
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Card title={translateX('vouchers')}>
      <Descriptions column={1} size="small" bordered>
        {(record?.travellers || []).map((t, i) => (
          <Descriptions.Item
            key={i}
            label={`${t.name || '—'} · ${parseCpfToDisplay(t.cpf) || '—'} · ${translateX(t.gender) || '—'}`}
          >
            {!t.voucherUrl ? (
              <Button
                icon={<UploadOutlined />}
                disabled={!canInsert}
                onClick={() => onInsert(t)}
              >
                {translateX('insert_voucher')}
              </Button>
            ) : (
              <Space>
                <Link href={t.voucherUrl} target="_blank">
                  <AuditOutlined /> {t.voucherNumber}
                </Link>
                <span>
                  <CarryOutOutlined />{' '}
                  {t.voucherDate ? dayjs(t.voucherDate).format('L') : '—'}
                </span>
                <Button
                  size="small"
                  icon={<EditOutlined />}
                  disabled={!canInsert}
                  onClick={() => onInsert(t)}
                />
              </Space>
            )}
          </Descriptions.Item>
        ))}
      </Descriptions>

      <AddVoucherModal
        open={open}
        passenger={selected}
        order={record}
        onClose={() => setOpen(false)}
        onSaved={onSaved}
      />
    </Card>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default VoucherTab;
